







import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  props: ['title', 'message'],
})
export default class Instruction extends Vue {}

